import { array, intersect, literal, number, partial, string, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { RefItem as UserRefItem } from '../../user/RefItem';

import { Type as Change } from './change/Type';
import { Type as Frame } from './frame/Type';
import { Id as StepId } from './step/Id';

export const DraftPreview = struct({
	pageNumber: iotsUtils.PositiveInteger1Based,
	version: number,
	frames: array(Frame),
});

export const DroppedDraftEdit = struct({
	type: string,
	reason: string,
});

export const RawChangeDraftEdit = struct({
	type: literal('raw-change'),
	stepId: StepId,
	change: Change,
});

export const FrameHeightUpdatedDraftEdit = struct({
	type: literal('frame-height-updated'),
	stepId: literal('height'),
	frameId: string,
	height: number,
	segmentHeights: array(
		struct({
			segmentId: string,
			height: number,
		})
	),
});

export const FrameThicknessUpdatedDraftEdit = struct({
	type: literal('frame-thickness-updated'),
	stepId: literal('thickness'),
	frameId: string,
	thickness: number,
	segmentThicknesses: array(
		struct({
			segmentId: string,
			thickness: number,
		})
	),
});

export const NormalizedDraftEdit = union(
	RawChangeDraftEdit,
	FrameHeightUpdatedDraftEdit,
	FrameThicknessUpdatedDraftEdit
);

export const DraftPage = intersect(
	struct({
		pageNumber: iotsUtils.PositiveInteger1Based,
		baseVersion: number,
		stepId: StepId,
		edits: iotsUtils.NonEmptyArray(NormalizedDraftEdit),
		preview: DraftPreview,
	})
)(
	partial({
		savedAt: string,
		savedBy: UserRefItem,
	})
);

export const Draft = struct({
	revision: string,
	pages: iotsUtils.NonEmptyArray(DraftPage),
});
